import { BoxBufferGeometry, Color, Mesh, MeshStandardMaterial, Object3D, Raycaster, Vector3 } from "three"
import { EffectNode } from '../../Core/EffectNode'
export class Floor extends EffectNode {
  constructor (props) {
    super(props)

    this.o3d = new Object3D()
    const ctx = this

    const floor = new Mesh(
      new BoxBufferGeometry(2000, 1, 6000, 2, 2, 2),
      new MeshStandardMaterial({ transparent: true, opacity: 1, color: new Color('#ffffff'), wireframe: false, map: ctx.root.chroma.out.texture })
    )
    ctx.root.chroma.out.texture.flipY = false
    floor.receiveShadow = true
    // floor.translateY(1)
    floor.geometry.translate(0, -4.5, 0)
    floor.userData.interactive = true
    floor.cursor = 'grab'
    floor.position.y += 10

    ctx.root.ammo.addSimpleMesh({ mesh: floor, mass: 0, rootScale: 1 })

    //
    // addMesh({ info: {}, mesh: floor, rootScale: 1, mass: 0 })

    let raycaster = new Raycaster()
    let tempPointer1 = new Vector3()
    let getFloorV3 = (coord, v3 = tempPointer1) => {
      raycaster.setFromCamera(coord, ctx.camera)
      let hit = raycaster.intersectObject(floor, false)
      // console.log(hit)
      let first = hit[0]
      if (first) {
        v3.x = first.point.x
        v3.y = 0
        v3.z = first.point.z
        console.log(v3.toArray().join(', '))
        return v3
      } else {
        return false
      }
    }

    let isDown = false
    let moved = 0
    floor.on('pointermove', () => {
      if (isDown) {
        moved++
        // console.log(moved)
      }
    })
    floor.on('pointerdown', () => {
      isDown = true
      ctx.root.controls.enabled = true
      floor.cursor = 'grabbing'
      moved = 0
    })

    floor.on('pointerup', (ev) => {
      isDown = false
      floor.cursor = 'grab'

      if (moved <= 10) {
        ctx.root.controls.enabled = true
        let position = getFloorV3(ev.data.global)
        ctx.root.events.emit('click-floor', { position: position })
      }
      moved = 0
    })

    // floor.receiveShadow = true


    // floor.on('click', () => {
    //   this.$emit('floor-click')
    //   console.log('onclick floor')
    //   ctx.$on('click-floor', )
    // })

    this.o3d.add(floor)

    this.root.scene.add(this.o3d)
  }
}
